<template>
  <div
    class="overlay-wrapper"
    :class="{ blocking: blocking, 'd-none': !shown }"
  >
    <div class="overlay">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverlayComponent",
  props: {
    blocking: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shown: false,
    };
  },
  methods: {
    show() {
      this.shown = true;
    },
    hide() {
      this.shown = false;
    },
  },
};
</script>

<style>
</style>
